//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: '',
  components: {
  },
  data () {
    return {
      inputValue: '',
      isInputFocused: false,
      isResultShow: false
    }
  },
  props: ['obj'],
  computed: {
    cancelStyle () {
      if (this.inputValue) {
        return 'block'
      } else {
        return 'none'
      }
    },
    resultClass () {
      if (this.inputValue.trim()) {
        return 'search-result_show'
      } else {
        return 'search-result_hide'
      }
    },


  },
  methods: {
    focusInput () {
      let input = document.getElementById('search_input')
      input.focus()
      this.isInputFocused = true
    },
    blurInput () {
      if (!this.inputValue.trim()) this.cancelSearch()
    },
    onInput () {
      this.isResultShow = this.inputValue.trim() ? true : false
    },
    onInputChange () {
      if (this.obj.action) {
        this.$emit(this.obj.action, inputValue)
      } else {
        this.$emit('search', inputValue)
      }
    },
    
    cancelSearch () {
      this.isInputFocused = false
      this.isResultShow = false
      this.inputValue = ''
    },
    clearSearch () {
      this.isResultShow = false
      this.inputValue = '' 
    },

    showSlidePanel () {
      this.$emit('filter')
    }
  },
}
